{
  "familyId": "TAA-SOORT-WW",
  "questions": [
    {
      "id": "TAA-SOORT-WW-001",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is het werkwoord in deze zin?\n'De kinderen spelen buiten in de tuin.'",
      "context": null,
      "options": ["spelen", "kinderen", "buiten", "tuin"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Wat is een werkwoord?", "content": "Een werkwoord beschrijft wat iemand doet, voelt of is. Vraag: 'Wat doen de kinderen?' Het antwoord is het werkwoord.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_herkennen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het werkwoord beschrijft wat de kinderen doen. Vraag: 'Wat doen de kinderen?' Antwoord: 'spelen'. Dus 'spelen' is het werkwoord. 'Kinderen' is een zelfstandig naamwoord, 'buiten' is een bijwoord, 'tuin' is een zelfstandig naamwoord.",
        "solutionSteps": [
          "Stel de vraag: 'Wat doen de kinderen?'",
          "Het antwoord is 'spelen'",
          "Dus 'spelen' is het werkwoord"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Spelen' is het werkwoord: het beschrijft wat de kinderen doen.",
          "1": "Je dacht waarschijnlijk dat 'kinderen' het werkwoord is. Maar 'kinderen' is een zelfstandig naamwoord — het antwoord op 'wie?'. Het werkwoord beschrijft wat ze doen: spelen. Onthoud: vraag 'Wat doen ze?' om het werkwoord te vinden.",
          "2": "Je dacht waarschijnlijk dat 'buiten' het werkwoord is. Maar 'buiten' is een bijwoord — het antwoord op 'waar?'. Het werkwoord beschrijft wat ze doen: spelen. Onthoud: een werkwoord beschrijft een handeling, niet een plaats.",
          "3": "Je dacht waarschijnlijk dat 'tuin' het werkwoord is. Maar 'tuin' is een zelfstandig naamwoord — een ding of plaats. Het werkwoord beschrijft wat ze doen: spelen. Onthoud: vraag 'Wat doen ze?' om het werkwoord te vinden."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-002",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is het werkwoord in deze zin?\n'Mijn moeder bakt elke zondag een taart.'",
      "context": null,
      "options": ["bakt", "moeder", "zondag", "taart"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Werkwoord vinden", "content": "Vraag: 'Wat doet mijn moeder?' → bakt. Dat is het werkwoord. Werkwoorden beschrijven een handeling, toestand of gevoel.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_handeling",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Vraag: 'Wat doet mijn moeder?' Antwoord: 'bakt'. Dus 'bakt' is het werkwoord. Het beschrijft de handeling (bakken).",
        "solutionSteps": [
          "Stel de vraag: 'Wat doet mijn moeder?'",
          "Het antwoord is 'bakt'",
          "Dus 'bakt' is het werkwoord (handeling: bakken)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Bakt' is het werkwoord: het beschrijft wat de moeder doet.",
          "1": "Je dacht waarschijnlijk dat 'moeder' het werkwoord is. Maar 'moeder' is een zelfstandig naamwoord — een persoon. Het werkwoord beschrijft wat ze doet: bakt. Onthoud: een werkwoord is een doe-woord, geen persoon.",
          "2": "Je dacht waarschijnlijk dat 'zondag' het werkwoord is. Maar 'zondag' is een zelfstandig naamwoord — een dag. Het werkwoord beschrijft wat ze doet: bakt. Onthoud: dagen en tijden zijn geen werkwoorden.",
          "3": "Je dacht waarschijnlijk dat 'taart' het werkwoord is. Maar 'taart' is een zelfstandig naamwoord — een ding. Het werkwoord beschrijft wat ze doet: bakt. Onthoud: vraag 'Wat doet ze?' om het werkwoord te vinden."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-003",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Hoeveel werkwoorden staan er in deze zin?\n'De hond rent snel en blaft luid.'",
      "context": null,
      "options": ["2", "1", "3", "0"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meerdere werkwoorden", "content": "Een zin kan meerdere werkwoorden hebben. Zoek alle woorden die beschrijven wat iemand doet: rent (wat doet de hond?) en blaft (wat doet de hond nog meer?).", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_meerdere",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "In deze zin zijn twee werkwoorden: 'rent' (wat doet de hond?) en 'blaft' (wat doet de hond nog meer?). 'Snel' en 'luid' zijn bijwoorden — ze beschrijven hoe de hond rent en blaft.",
        "solutionSteps": [
          "Vraag: 'Wat doet de hond?' → rent",
          "Vraag: 'Wat doet de hond nog meer?' → blaft",
          "'Snel' en 'luid' beschrijven hoe → bijwoorden, geen werkwoorden",
          "Er zijn 2 werkwoorden: rent en blaft"
        ],
        "distractorExplanations": {
          "0": "Goed! Er zijn twee werkwoorden: 'rent' en 'blaft'. Beide beschrijven wat de hond doet.",
          "1": "Je dacht waarschijnlijk dat er maar 1 werkwoord is. Maar de hond doet twee dingen: rennen én blaffen. Beide zijn werkwoorden. Onthoud: een zin kan meerdere werkwoorden hebben — zoek alle doe-woorden.",
          "2": "Je dacht waarschijnlijk dat 'snel' of 'luid' ook werkwoorden zijn. Maar 'snel' en 'luid' zijn bijwoorden — ze beschrijven hoe iets gebeurt, niet wat er gebeurt. Onthoud: een werkwoord beschrijft de handeling zelf, niet hoe die handeling is.",
          "3": "Je dacht waarschijnlijk dat er geen werkwoorden in de zin staan. Maar 'rent' en 'blaft' zijn allebei werkwoorden — ze beschrijven wat de hond doet. Onthoud: bijna elke zin heeft minstens één werkwoord."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-004",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN werkwoord?",
      "context": null,
      "options": ["snel", "rennen", "slapen", "lachen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Werkwoord of niet?", "content": "Werkwoorden beschrijven een handeling, toestand of gevoel: rennen, slapen, lachen.\nBijvoeglijke naamwoorden beschrijven een eigenschap: snel, groot, mooi.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_onderscheid",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Snel' is een bijvoeglijk naamwoord — het beschrijft een eigenschap (hoe snel?). 'Rennen', 'slapen' en 'lachen' zijn werkwoorden — ze beschrijven handelingen of toestanden.",
        "solutionSteps": [
          "Controleer elk woord: beschrijft het een handeling, toestand of gevoel?",
          "'Rennen' → beschrijft een handeling → werkwoord ✓",
          "'Slapen' → beschrijft een toestand → werkwoord ✓",
          "'Lachen' → beschrijft een handeling → werkwoord ✓",
          "'Snel' → beschrijft een eigenschap (hoe is iets?) → bijvoeglijk naamwoord, geen werkwoord"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Snel' is een bijvoeglijk naamwoord, geen werkwoord. Het beschrijft een eigenschap.",
          "1": "Je dacht waarschijnlijk dat 'rennen' geen werkwoord is. Maar 'rennen' beschrijft een handeling — iets wat je kunt doen. Onthoud: als je het kunt doen, is het een werkwoord.",
          "2": "Je dacht waarschijnlijk dat 'slapen' geen werkwoord is. Maar 'slapen' beschrijft een toestand — iets wat je kunt doen. Onthoud: ook toestanden (slapen, zitten, liggen) zijn werkwoorden.",
          "3": "Je dacht waarschijnlijk dat 'lachen' geen werkwoord is. Maar 'lachen' beschrijft een handeling — iets wat je kunt doen. Onthoud: als je het kunt doen, is het een werkwoord."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-005",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is het werkwoord in deze zin?\n'Het kleine meisje is heel gelukkig.'",
      "context": null,
      "options": ["is", "meisje", "kleine", "gelukkig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "'Zijn' als werkwoord", "content": "'Zijn' (ben/bent/is/zijn) is ook een werkwoord! Het beschrijft een toestand. Vraag: 'Wat is het meisje?' → is gelukkig. 'Is' is het werkwoord.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "werkwoord_zijn_toestand",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "'Is' is het werkwoord in deze zin. 'Zijn' (ben/bent/is/zijn) is een werkwoord dat een toestand beschrijft. 'Kleine' en 'gelukkig' zijn bijvoeglijke naamwoorden, 'meisje' is een zelfstandig naamwoord.",
        "solutionSteps": [
          "Zoek het werkwoord: wat doet of is het meisje?",
          "Het meisje 'is' gelukkig → 'is' beschrijft de toestand",
          "'Is' is een vorm van 'zijn' → werkwoord",
          "'Kleine' en 'gelukkig' beschrijven eigenschappen → bijvoeglijke naamwoorden"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Is' is het werkwoord. Het beschrijft de toestand van het meisje.",
          "1": "Je dacht waarschijnlijk dat 'meisje' het werkwoord is. Maar 'meisje' is een zelfstandig naamwoord — een persoon. Het werkwoord is 'is' (een vorm van 'zijn'). Onthoud: 'zijn' is ook een werkwoord, ook al beschrijft het geen handeling.",
          "2": "Je dacht waarschijnlijk dat 'kleine' het werkwoord is. Maar 'kleine' is een bijvoeglijk naamwoord — het beschrijft hoe het meisje eruitziet. Het werkwoord is 'is'. Onthoud: woorden die beschrijven hoe iets eruitziet zijn bijvoeglijke naamwoorden.",
          "3": "Je dacht waarschijnlijk dat 'gelukkig' het werkwoord is. Maar 'gelukkig' is een bijvoeglijk naamwoord — het beschrijft een eigenschap. Het werkwoord is 'is'. Onthoud: 'zijn' (ben/bent/is) is het werkwoord, 'gelukkig' beschrijft de eigenschap."
        }
      }
    },
    {
      "id": "TAA-SOORT-WW-006",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste woordsoort.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "rennen", "right": "werkwoord" },
          { "left": "tafel", "right": "zelfstandig naamwoord" },
          { "left": "snel", "right": "bijvoeglijk naamwoord" },
          { "left": "de", "right": "lidwoord" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woordsoorten herkennen",
            "content": "Werkwoord = doe-woord (rennen, lopen). Zelfstandig naamwoord = persoon/dier/ding (tafel, hond). Bijvoeglijk naamwoord = eigenschap (snel, groot). Lidwoord = de, het, een.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "werkwoord_matching_woordsoorten",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Rennen = werkwoord (je kunt het doen). Tafel = zelfstandig naamwoord (een ding). Snel = bijvoeglijk naamwoord (een eigenschap). De = lidwoord (staat voor een zelfstandig naamwoord).",
        "solutionSteps": [
          "Rennen → kun je het doen? Ja → werkwoord",
          "Tafel → is het een ding/persoon? Ja → zelfstandig naamwoord",
          "Snel → beschrijft het een eigenschap? Ja → bijvoeglijk naamwoord",
          "De → staat het voor een znw? Ja → lidwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-007",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan het juiste type.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "lopen", "right": "handeling" },
          { "left": "slapen", "right": "toestand" },
          { "left": "houden van", "right": "gevoel" },
          { "left": "zijn", "right": "koppelwerkwoord" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten werkwoorden",
            "content": "Handelingswerkwoord = iets doen (lopen, eten). Toestandswerkwoord = een toestand (slapen, liggen). Gevoelswerkwoord = een gevoel (houden van, haten). Koppelwerkwoord = zijn, worden, blijven.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "werkwoord_matching_types",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Lopen = handeling (je doet iets). Slapen = toestand (je bent ergens). Houden van = gevoel (je voelt iets). Zijn = koppelwerkwoord (verbindt onderwerp met eigenschap).",
        "solutionSteps": [
          "Lopen → doe je iets? Ja → handeling",
          "Slapen → is het een toestand? Ja → toestand",
          "Houden van → is het een gevoel? Ja → gevoel",
          "Zijn → verbindt het onderwerp met eigenschap? Ja → koppelwerkwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-008",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "matching",
      "question": "Koppel elk woord uit de zin aan de juiste woordsoort. Zin: 'De grote hond blaft luid.'",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "blaft", "right": "werkwoord" },
          { "left": "hond", "right": "zelfstandig naamwoord" },
          { "left": "grote", "right": "bijvoeglijk naamwoord" },
          { "left": "luid", "right": "bijwoord" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woordsoorten in een zin",
            "content": "Werkwoord = wat doet de hond? → blaft. Zelfstandig naamwoord = wie/wat? → hond. Bijvoeglijk naamwoord = hoe is de hond? → grote. Bijwoord = hoe blaft hij? → luid.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "werkwoord_matching_zin",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Blaft = werkwoord (wat doet de hond?). Hond = zelfstandig naamwoord (wie/wat?). Grote = bijvoeglijk naamwoord (hoe is de hond?). Luid = bijwoord (hoe blaft hij?).",
        "solutionSteps": [
          "Blaft → wat doet de hond? → werkwoord",
          "Hond → wie/wat? → zelfstandig naamwoord",
          "Grote → hoe is de hond? → bijvoeglijk naamwoord",
          "Luid → hoe blaft hij? → bijwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-009",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "categorize",
      "question": "Sorteer de woorden in de juiste categorie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Werkwoord", "Zelfstandig naamwoord", "Bijvoeglijk naamwoord"],
        "items": [
          { "text": "lopen", "correctCategory": 0 },
          { "text": "hond", "correctCategory": 1 },
          { "text": "mooi", "correctCategory": 2 },
          { "text": "spelen", "correctCategory": 0 },
          { "text": "tafel", "correctCategory": 1 },
          { "text": "groot", "correctCategory": 2 }
        ]
      },
      "conceptId": "woordsoort_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Werkwoorden geven een handeling aan (lopen, spelen). Zelfstandige naamwoorden zijn mensen, dieren of dingen (hond, tafel). Bijvoeglijke naamwoorden zeggen iets over een zelfstandig naamwoord (mooi, groot).",
        "solutionSteps": [
          "Werkwoorden: wat je kunt doen (lopen, spelen)",
          "Zelfstandige naamwoorden: waar je 'de', 'het' of 'een' voor kunt zetten (hond, tafel)",
          "Bijvoeglijke naamwoorden: hoe iets is (mooi, groot)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-010",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "categorize",
      "question": "Sorteer de woorden in de juiste categorie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Werkwoord", "Zelfstandig naamwoord", "Bijvoeglijk naamwoord"],
        "items": [
          { "text": "fietsen", "correctCategory": 0 },
          { "text": "boom", "correctCategory": 1 },
          { "text": "snel", "correctCategory": 2 },
          { "text": "lezen", "correctCategory": 0 },
          { "text": "boek", "correctCategory": 1 },
          { "text": "dik", "correctCategory": 2 }
        ]
      },
      "conceptId": "woordsoort_categorize_2",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Werkwoorden geven een handeling aan (fietsen, lezen). Zelfstandige naamwoorden zijn mensen, dieren of dingen (boom, boek). Bijvoeglijke naamwoorden zeggen iets over een zelfstandig naamwoord (snel, dik).",
        "solutionSteps": [
          "Werkwoorden: wat je kunt doen (fietsen, lezen)",
          "Zelfstandige naamwoorden: waar je 'de', 'het' of 'een' voor kunt zetten (boom, boek)",
          "Bijvoeglijke naamwoorden: hoe iets is (snel, dik)"
        ]
      }
    }
  ]
}